import { ApiRequest } from '../baseService'

const BaseRoute = 'app/account'

function getProfile() {
  return ApiRequest.get(`${BaseRoute}/my-profile`)
}

function updateProfile(data) {
  return ApiRequest.put(`${BaseRoute}/my-profile`, data)
}

function changePassword(data) {
  return ApiRequest.put(`${BaseRoute}/change-password`, data)
}

function resetAuthenticatorKey() {
  return ApiRequest.post(`${BaseRoute}/reset-authenticator-key`)
}

function getAuthenticatorKey() {
  return ApiRequest.post(`${BaseRoute}/get-authenticator-key`)
}

function verifyAuthenticationCode(code) {
  return ApiRequest.post(`${BaseRoute}/verify-authentication-code`, { code })
}

function generateTwoFactorRecoveryCodes() {
  return ApiRequest.post(`${BaseRoute}/generate-recovery-codes`)
}

function updateTwoFactorStatus(isEnabled) {
  return ApiRequest.post(
    `${BaseRoute}/update-two-factor-status?isEnabled=${isEnabled}`
  )
}
const API = {
  getProfile,
  updateProfile,
  changePassword,
  resetAuthenticatorKey,
  verifyAuthenticationCode,
  generateTwoFactorRecoveryCodes,
  getAuthenticatorKey,
  updateTwoFactorStatus,
}

export default API
